<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--procurement procurement-widget">
        <div class="card-header procurement-widget__header">
            <div>
                <h6 class="mb-0 fw-bold dashboard-widget__title procurement-widget__title">
                    <span class="dashboard-widget__icon procurement-widget__icon" v-html="sidebarSvg.procurement"></span>
                    <span>{{ $t('Procurement') }}</span>
                </h6>
            </div>
            <div class="procurement-widget__legend" aria-label="Procurement round legend">
                <span><i class="procurement-widget__legend-dot procurement-widget__legend-dot--ongoing"></i>{{ $t('Ongoing Round') }}</span>
                <span><i class="procurement-widget__legend-dot procurement-widget__legend-dot--concluded"></i>{{ $t('Concluded Round') }}</span>
                <span><i class="procurement-widget__legend-dot procurement-widget__legend-dot--procurement"></i>{{ $t('Procurement Round') }}</span>
            </div>
        </div>
        <div class="card-body procurement-widget__body">
            <div class="procurement-widget__summary-grid">
                <div class="procurement-widget__metric">
                    <strong>{{data.tradesProcured}}/{{data.tradesNotProcured}}</strong>
                    <span>{{ $t('Trade Package Awarded')}}</span>
                </div>
                <div class="procurement-widget__metric">
                    <strong>{{data.lineItemsAttachedToTradePackage}}/{{data.lineItemsNotAttachedToTradePackage}}</strong>
                    <span>{{ $t('Line Items attached to Trade Packages')}}</span>
                </div>
                <div class="procurement-widget__metric">
                    <strong>{{displayPercentage}}%</strong>
                    <span>{{ $t('Progress') }}</span>
                </div>
                <div class="procurement-widget__metric">
                    <strong>{{data.upcomingTradePackageRounds.length}}</strong>
                    <span>{{ $t('Upcoming Procurement Events')}}</span>
                </div>
            </div>

            <div class="procurement-widget__progress">
                <div class="procurement-widget__progress-label">
                    <span>{{ $t('Progress') }}</span>
                    <strong>{{displayPercentage}}%</strong>
                </div>
                <div class="procurement-widget__progress-track" role="progressbar" :aria-valuenow="displayPercentage" aria-valuemin="0" aria-valuemax="100">
                    <div class="procurement-widget__progress-bar" :style="{width: displayPercentage + '%'}"></div>
                </div>
            </div>

            <div class="procurement-widget__footer">
                <button class="btn procurement-widget__toggle" @click="()=>{showEvents = !showEvents}">
                    {{ $t('Toggle Upcoming Events')}}
                </button>
            </div>

            <div class="procurement-widget__events" v-show="showEvents">
                <div class="procurement-widget__events-header">
                    <span>{{ $t('Upcoming Procurement Events')}}</span>
                    <strong>{{data.upcomingTradePackageRounds.length}}</strong>
                </div>
                <div class="procurement-widget__events-body">
                    <div class="procurement-widget__empty" v-if="data.upcomingTradePackageRounds.length==0">
                        {{ $t('No Upcoming Rounds')}}
                    </div>
                    <div class="procurement-widget__event" v-for="(item,key) in data.upcomingTradePackageRounds" :key="key">
                        <span :class="['procurement-widget__status', GetStatusClass(item.statusId)]">{{ item.statusName }}</span>
                        <span class="procurement-widget__date">{{ ReformatDate(item.roundDate) }}</span>
                        <span class="procurement-widget__name">{{item.tradePackageName }}</span>
                        <span class="procurement-widget__round">{{ $t('Round') }} {{item.round - 1 }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {DashboardGetTradePackageProcurement} from '@/actions/projectActions.js'
import {ReformatNumber, ReformatDate} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
export default {
    name : 'ProcurementDetails',
    props : ['projectInfo'],
    data(){
        return {
            data : { 
                lineItemsAttachedToTradePackage : 0, 
                lineItemsNotAttachedToTradePackage : 0,
                tradesNotProcured : 0,
                tradesProcured : 0,
                upcomingTradePackageRounds : [],
                percentage : 0,
            },
            showEvents : false,
            sidebarSvg
            
        }
    },
    mounted : async function(){
        const self = this

        const response = await DashboardGetTradePackageProcurement(self.projectInfo._id)
        if(!response)
            return
        const lineItemTotal = Number(response.data.lineItemsNotAttachedToTradePackage) || 0
        const tradeTotal = Number(response.data.tradesNotProcured) || 0
        let first50 = lineItemTotal > 0 ? Math.round((response.data.lineItemsAttachedToTradePackage / lineItemTotal) * 50) : 0
        let second50 = tradeTotal > 0 ? Math.round((response.data.tradesProcured / tradeTotal) * 50) : 0
        self.data = response.data
        self.data.percentage = first50 + second50;

    },
    methods :{
        ReformatNumber,
        ReformatDate,
        GetStatusClass(statusId){
            const statusClasses = {
                1 : 'procurement-widget__status--ongoing',
                2 : 'procurement-widget__status--concluded',
                3 : 'procurement-widget__status--procurement'
            }
            return statusClasses[statusId] || 'procurement-widget__status--ongoing'
        }
    },
    computed : {
        displayPercentage(){
            const percentage = Number(this.data.percentage) || 0
            return Math.max(0, Math.min(100, percentage))
        }
    }
    
} 
</script>

<style scoped>
.procurement-widget {
    --procurement-accent: #ae8f00;
    --procurement-accent-dark: #8f7600;
    --procurement-accent-soft: #f4edc8;
    --procurement-line: #d4b52c;
    --procurement-row-soft: #f8f4df;
    --procurement-row-muted: #dfddd7;
    border: 0;
    background: #ffffff;
    box-shadow: 0 0.8rem 1.8rem rgba(65, 55, 24, 0.08) !important;
}

.procurement-widget__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    border-bottom: 1px solid var(--procurement-line) !important;
    background: var(--procurement-accent-soft) !important;
    padding: 0.9rem 1rem;
}

.procurement-widget__title {
    color: var(--procurement-accent) !important;
    font-size: 1.05rem;
}

.procurement-widget__icon {
    color: var(--procurement-accent);
}

.procurement-widget__icon :deep(svg *) {
    stroke: currentColor !important;
}

.procurement-widget__legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.55rem;
    color: #2f332b;
    font-size: 0.68rem;
    font-weight: 700;
    line-height: 1.2;
}

.procurement-widget__legend span {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    white-space: nowrap;
}

.procurement-widget__legend-dot {
    display: inline-flex;
    width: 0.45rem;
    height: 0.45rem;
    border-radius: 0.08rem;
}

.procurement-widget__legend-dot--ongoing {
    background: #0d75a7;
}

.procurement-widget__legend-dot--concluded {
    background: var(--procurement-accent);
}

.procurement-widget__legend-dot--procurement {
    background: #298969;
}

.procurement-widget__body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem !important;
    background: #ffffff !important;
}

.procurement-widget__summary-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0.75rem;
}

.procurement-widget__metric {
    display: flex;
    min-height: 4.25rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #dedbd0;
    background: #ffffff;
    box-shadow: 0 0.35rem 0.9rem rgba(41, 35, 16, 0.06);
    text-align: center;
}

.procurement-widget__metric strong {
    color: #1e1b16;
    font-size: 1.12rem;
    font-weight: 500;
    line-height: 1.1;
}

.procurement-widget__metric span {
    margin-top: 0.35rem;
    color: #2f332b;
    font-size: 0.68rem;
    font-weight: 700;
    line-height: 1.2;
}

.procurement-widget__progress {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.procurement-widget__progress-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #2f332b;
    font-size: 0.78rem;
    font-weight: 800;
}

.procurement-widget__progress-label strong {
    color: var(--procurement-accent);
}

.procurement-widget__progress-track {
    overflow: hidden;
    height: 0.65rem;
    border-radius: 999px;
    background: #edece6;
}

.procurement-widget__progress-bar {
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, var(--procurement-accent), var(--procurement-accent-dark));
}

.procurement-widget__footer {
    display: flex;
    justify-content: flex-start;
}

.procurement-widget__toggle,
.procurement-widget__toggle:hover,
.procurement-widget__toggle:focus {
    display: inline-flex;
    min-height: 2.15rem;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--procurement-accent) !important;
    border-radius: 0 !important;
    padding: 0.45rem 1.05rem;
    color: #ffffff !important;
    background: var(--procurement-accent) !important;
    font-size: 0.78rem;
    font-weight: 800;
    line-height: 1;
    box-shadow: none !important;
}

.procurement-widget__events {
    overflow: hidden;
    border: 1px solid #dedbd0;
    background: #ffffff;
}

.procurement-widget__events-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--procurement-line);
    padding: 0.75rem 0.9rem;
    color: var(--procurement-accent);
    background: var(--procurement-accent-soft);
    font-size: 0.78rem;
    font-weight: 800;
}

.procurement-widget__events-header strong {
    display: inline-flex;
    min-width: 1.6rem;
    height: 1.35rem;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    color: #ffffff;
    background: var(--procurement-accent);
    font-size: 0.7rem;
}

.procurement-widget__events-body {
    display: flex;
    flex-direction: column;
}

.procurement-widget__event {
    display: grid;
    grid-template-columns: 5.75rem 6.25rem minmax(0, 1fr) 4.25rem;
    align-items: center;
    gap: 0.6rem;
    border-bottom: 1px solid #e7e2d0;
    padding: 0.65rem 0.9rem;
    background: #ffffff;
    color: #1e1b16;
    font-size: 0.76rem;
    font-weight: 600;
    line-height: 1.25;
}

.procurement-widget__event:nth-child(odd) {
    background: #ffffff;
}

.procurement-widget__event:nth-child(even) {
    background: #ffffff;
}

.procurement-widget__event:last-child {
    border-bottom: 0;
}

.procurement-widget__status {
    display: inline-flex;
    min-height: 1.35rem;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    padding: 0.25rem 0.55rem;
    color: #ffffff;
    font-size: 0.62rem;
    font-weight: 800;
    line-height: 1;
    text-transform: uppercase;
}

.procurement-widget__status--ongoing {
    background: #0d9bd7;
}

.procurement-widget__status--concluded {
    background: var(--procurement-accent);
}

.procurement-widget__status--procurement {
    background: #298969;
}

.procurement-widget__date {
    font-weight: 800;
    white-space: nowrap;
}

.procurement-widget__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.procurement-widget__round {
    color: #6a6252;
    text-align: right;
    white-space: nowrap;
}

.procurement-widget__empty {
    padding: 1.25rem 1rem;
    color: #777777;
    background: #ffffff;
    font-size: 0.82rem;
    font-weight: 800;
    text-align: center;
}

@media (max-width: 991.98px) {
    .procurement-widget__summary-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .procurement-widget__event {
        grid-template-columns: 5.75rem minmax(0, 1fr);
    }

    .procurement-widget__round {
        text-align: left;
    }
}

@media (max-width: 767.98px) {
    .procurement-widget__header {
        flex-direction: column;
    }

    .procurement-widget__legend {
        justify-content: flex-start;
    }

    .procurement-widget__summary-grid {
        grid-template-columns: 1fr;
    }
}
</style>
